document.addEventListener('cart:updated', ({ detail: { items } }) => {
  setTimeout(() => {
    const goalText = document.querySelector('.mu-goal-text');
    if (goalText) {
      const goalTexts = goalText.querySelectorAll('.mu-text-center');
      // console.log(goalTexts.length);
      if (goalTexts.length > 1) {
        // console.log(goalTexts);
        goalTexts.forEach((text, index) => {
          if (index !== goalTexts.length - 1) {
            text.style.display = 'none';
          }
        });
      } else {
        // console.log(goalTexts);
        goalTexts[0].style.display = 'block';
      }
    }
  }, 200);
});
